(function() {
    $(document).ready(function() {

        $('.c24m-sab').on('click', function(event) {

            if ($(event.target).hasClass('c24m-sab-close')) {
                return;
            }

            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'app-banner',
                'app-banner:click',
            ]);
        });

        $('.c24m-sab-close').on('click', function() {

            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'app-banner',
                'app-banner:delete',
            ]);
        });
    });
})();
